export default class DtoEsu {
    constructor(object) {
        this.codequalitometre = object.codequalitometre
        this.codebss = object.codebss
        this.codereseau = object.codereseau
    }
}